import EmailSimpleForm from './EmailSimpleForm'
export default EmailSimpleForm
